import { Injectable } from '@angular/core';

// Environment
import { environment } from '@environments/environment';

// HandleError
import { handleError } from '@shared-functions/handle-error.function';

// HTTP
import { HttpClient } from '@angular/common/http';

// Interfaces
import { GenericResponse } from '@shared-interfaces/generic-response.interface';
import { Permisos } from '../interfaces/permisos.interface';

// RxJS
import { BehaviorSubject, catchError, filter, map, Observable, tap } from 'rxjs';
import { PermisosPorRecurso } from 'src/app/roles/interfaces/permiso-x-recurso.interface';

@Injectable({
  providedIn: 'root',
})
export class PermisosService {
  private API_SERVER = environment.API_SERVER;

  permisos = new BehaviorSubject<Permisos | null>(null);

  private permisosRol = new BehaviorSubject<PermisosPorRecurso[] | null>(null);

  permisosRol$ = this.permisosRol.asObservable();

  constructor(private http: HttpClient) {}

  // PUTS
  updatePermisos(permisosId: number, permisosForm: any): Observable<GenericResponse> {
    return this.http
      .put<GenericResponse>(`${this.API_SERVER}/permission/${permisosId}`, permisosForm)
      .pipe(catchError(handleError));
  }
  actualizarPermisosDeEntidad(
    rolId: number,
    data: { permisoId: number; estado: string }[],
  ): Observable<GenericResponse> {
    return this.http.put<GenericResponse>(`${this.API_SERVER}/permission/recursos/${rolId}`, data);
  }

  hasPermiso(codigo: string, recurso: string): Observable<boolean> {
    return this.permisosRol$.pipe(
      filter((permisos): permisos is PermisosPorRecurso[] => permisos !== null),
      map((permisos) => {
        const recursoEncontrado = permisos.find((p) => p.recurso === recurso);
        if (!recursoEncontrado) return false;

        return recursoEncontrado.permisos.some(
          (p) => p.codigo === codigo && p.estadoAccion === 'A',
        );
      }),
    );
  }
  permisoPorAccion$: Observable<Record<string, Record<string, boolean>>> = this.permisosRol$.pipe(
    filter((permisos): permisos is PermisosPorRecurso[] => permisos !== null),
    map((lista) => {
      const permisosPorRecurso: Record<string, Record<string, boolean>> = {};

      for (const recurso of lista) {
        const recursoKey = recurso.recurso.toUpperCase();

        if (!permisosPorRecurso[recursoKey]) {
          permisosPorRecurso[recursoKey] = {};
        }

        for (const permiso of recurso.permisos) {
          const codigoAccion = permiso.codigo.toUpperCase();
          permisosPorRecurso[recursoKey][codigoAccion] = permiso.estadoPermiso === 'A';
        }
      }

      return permisosPorRecurso;
    }),
  );
  setPermisosRol(permisos: PermisosPorRecurso[]): void {
    this.permisosRol.next(permisos);
  }
  limpiarPermisos(): void {
    this.permisosRol.next(null);
    localStorage.removeItem('permisosRol');
  }
}
